import { ErrorCode as AuthnErrorCode } from '@imprivata-cloud/authn';
import type { Dispatch } from 'redux';
import { setInternetConnectivityStatusAction } from '../store/actions';
import { endJourneyAndCloseWindow } from '../agent-api';
import { InternetConnectivityStatus } from '../constants';
import { isDesktopAccess } from '../utils/utils';
import { ErrorCode } from './new/types';
import { log } from '../utils/logging';
import { getTraceContext } from '../tracing/traceContext';

export const mapErrorToAction = (
  error: ErrorCode | AuthnErrorCode,
  dispatch: Dispatch,
): void => {
  const traceContext = getTraceContext();
  log('Handled error:', error);
  switch (error) {
    case ErrorCode.IID_AUTH_ERROR:
    case ErrorCode.PUSH_NOTIFICATION_REJECTED:
    case ErrorCode.TERMINATE_BY_TIMEOUT:
      endJourneyAndCloseWindow(traceContext.workflowId, traceContext);
      break;
    case AuthnErrorCode.NETWORK_ERROR:
    case ErrorCode.NETWORK_ERROR:
      // DA: the offline screen takes over; the agent's authentication status is left alone
      if (isDesktopAccess()) {
        dispatch(
          setInternetConnectivityStatusAction(
            InternetConnectivityStatus.DISCONNECTED,
          ),
        );
      }
      break;
  }
};
